import styled from '@emotion/styled';
import {
  fonts,
  media,
  pxToCssFont,
  sunriseSemanticTokens,
  sunriseSemanticTokens as theme,
} from '@vfit/shared/themes';

export const PromotionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  margin-top: ${theme.spacing.lg};
`;

export const PromotionDisclaimer = styled.p`
  color: ${sunriseSemanticTokens.colors.text.primary};
  font-family: ${fonts.vodafone};
  font-size: ${theme.typography.fontSize.body1};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: ${theme.typography.lineHeight.body1};
  margin: 0;

  * {
    margin: 0;
  }
`;

export const PromotionTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  align-self: stretch;
`;

export const PromotionTitle = styled.div`
  color: ${sunriseSemanticTokens.colors.text.error};
  font-family: ${fonts.vodafone};
  font-size: ${theme.typography.fontSize.h6};
  font-style: normal;
  line-height: ${theme.typography.lineHeight.h5};
  margin: 0;

  * {
    margin: 0;
  }
`;

export const LabelCta = styled.div`
  text-decoration: underline;
  cursor: pointer;
  color: ${sunriseSemanticTokens.colors.text.primary};
  font-family: ${fonts.vodafone};
  font-size: ${theme.typography.fontSize.body1};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: ${theme.typography.lineHeight.body1};
  margin: 0;
  margin-top: ${theme.spacing.md};
  * {
    margin: 0;
  }

  ${media.largeDesktop`
    ${pxToCssFont(16, 22)};
  `}
`;

